module.exports = __webpack_public_path__ + "img/pro-5-gen-landscape.1f03e19.png";